import React from "react";

const MissionVisionAreaSecton = () => {
  return (
    <>
      <section className="space bg-light">
        <div
          className="container"
          style={{
            backgroundImage: "url(/assets/img/bg/map-bg.png)",
          }}
        >
          <div className="row justify-content-center text-center">
            <div className="col-xxl-8 col-xl-8 col-lg-8 col-md-8">
              <div className="title-area">
                <span className="sec-subtitle">Our Purpose & Future</span>
                <h2 className="sec-title h1">Our Mission & Vision</h2>
              </div>
            </div>
          </div>

          <div className="row mt-60 mb-70">
            <div className="col-lg-6 col-md-6 history-steped">
              <span className="divider"></span>
              <div className="vs-history">
                <div className="header-area">
                  <h3 className="history-title">Mission</h3>
                </div>
                <p className="history-text" style={{ textAlign: "justify" }}>
                  To deliver comfort, affordability, and hospitality through
                  well-maintained vacation properties and exceptional service.
                </p>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 history-steped">
              <span className="divider"></span>
              <div className="vs-history">
                <div className="header-area">
                  <h3 className="history-title">Vision</h3>
                </div>
                <p className="history-text" style={{ textAlign: "justify" }}>
                  To become one of the UAE’s most trusted and customer-focused
                  vacation home providers.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MissionVisionAreaSecton;
